import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .create-invite-code-modal {
    width: 320px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .input-wrapper {
    margin-bottom: 8px;
  }
  .creating-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
  }
  .creating-message {
    margin-top: 16px;
    font-size: 14px;
    color: #676767;
    text-align: center;
  }
  .create-invite-code-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .create-invite-code-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .create-invite-code-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .create-invite-code-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
